<template lang='pug'>
  i.svg-icon.svg-icon-chrome
    svg(
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 100 100'
    )
      path(fill='#E64637' d='M18.444,23.109C37.81,0.574,73.716,5.021,87.135,31.347c-9.451,0.006-24.244-0.005-32.257,0 c-5.811,0-9.565-0.13-13.627,2.01c-4.775,2.516-8.383,7.176-9.638,12.653L18.444,23.109z')
      path(fill='#368BCB' d='M36.185,50.253c0,7.639,6.212,13.851,13.845,13.851c7.634,0,13.846-6.212,13.846-13.851 s-6.212-13.85-13.846-13.85C42.391,36.397,36.185,42.614,36.185,50.253z')
      path(fill='#4DA74F' d='M55.398,68.384c-7.769,2.307-16.866-0.25-21.843-8.852c-3.801-6.561-13.851-24.062-18.412-32.022 c-15.996,24.514-2.213,57.916,26.82,63.618L55.398,68.384z')
      path(fill='#F5BB1D' d='M62.886,36.397c6.473,6.019,7.883,15.767,3.499,23.322C63.084,65.416,52.54,83.208,47.432,91.82 c29.914,1.843,51.721-27.472,41.869-55.428L62.886,36.397z')


</template>

<script>
export default {

  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '#333',
    },
  },
};
</script>
